import { milestones } from '@/mocks/articles';

const cardColors = [
  'bg-[#f5e6e0]',
  'bg-[#dce8e0]',
  'bg-[#e8e4e0]',
  'bg-[#e8dcc8]',
];

export default function AboutMilestones() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-start justify-between mb-12">
          <div>
            <p className="font-heading text-xs tracking-widest uppercase text-foreground-400 mb-2">
              时间线 · 历程
            </p>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
              发展<span className="italic font-normal text-accent-500">历程</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {milestones.map((milestone, index) => (
            <div
              key={index}
              className="group rounded-2xl overflow-hidden transition-transform duration-300 hover:-translate-y-1 cursor-pointer flex flex-col"
            >
              <div className={`${cardColors[index]} aspect-[3/2] overflow-hidden`}>
                <img
                  src={milestone.imageUrl}
                  alt={milestone.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="bg-background-50 p-5 flex flex-col gap-2">
                <span className="text-xs text-accent-500 font-bold">{milestone.year}</span>
                <h3 className="text-base font-semibold text-foreground-950 leading-snug">
                  {milestone.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {milestone.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}